import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowDownLeft, ArrowUpRight, Users } from 'lucide-react';
import { formatoMonto, useAnalisis } from './useAnalisis';
import { PanelAnalisis } from './PanelAnalisis';

const Lista = ({ titulo, icono: Icono, filas, lado, onAbrir }) => (
  <div>
    <p className="mb-2 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
      <Icono size={13} /> {titulo}
    </p>
    {filas.length === 0 ? <p className="text-xs text-slate-400">Sin datos</p> : (
      <ol className="divide-y divide-slate-100 rounded-lg border border-slate-100">
        {filas.map((c, i) => (
          <li key={`${c.cuit || c.cvu}-${i}`} data-testid={`contraparte-${lado}-${i}`}
            onClick={() => c.es_cliente && onAbrir(c.cuit)}
            className={`flex items-center gap-3 px-3 py-2 text-sm transition-colors ${c.es_cliente ? 'cursor-pointer hover:bg-sky-50' : ''}`}>
            <span className="w-5 text-right text-xs text-slate-400">{i + 1}</span>
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium text-slate-800">{c.nombre || 'Sin nombre'}</p>
              <p className="font-mono text-[11px] text-slate-400">{c.cuit || c.cvu || '—'}</p>
            </div>
            {c.cliente_waya && (
              <span className="rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-semibold text-sky-700" data-testid={`contraparte-waya-${lado}-${i}`}>Cliente Waya</span>
            )}
            <span className="w-10 text-right text-xs text-slate-500">{c.cantidad}</span>
            <span className="w-28 text-right font-mono text-xs font-semibold text-slate-800">{formatoMonto(c.monto)}</span>
          </li>
        ))}
      </ol>
    )}
  </div>
);

// D3 / F3: los 10 orígenes y los 10 destinos con más monto. Clic: abre la ficha si la contraparte es cliente.
export const Contrapartes = ({ cuit, casoId, episodioId, desde, hasta }) => {
  const navigate = useNavigate();
  const { data, loading, error } = useAnalisis({ cuit, casoId, episodioId, desde, hasta });
  const cp = data?.contrapartes || { origenes: [], destinos: [] };
  const abrir = (c) => navigate(`/m/clientes/cliente/${c}`);
  return (
    <PanelAnalisis titulo="Principales contrapartes" icono={Users} testid="contrapartes" loading={loading} error={error}
      vacio={data && !cp.origenes.length && !cp.destinos.length ? 'Sin movimientos en el período' : null}>
      <div className="grid gap-5 lg:grid-cols-2">
        <Lista titulo="Orígenes (ingresos)" icono={ArrowDownLeft} filas={cp.origenes} lado="origen" onAbrir={abrir} />
        <Lista titulo="Destinos (egresos)" icono={ArrowUpRight} filas={cp.destinos} lado="destino" onAbrir={abrir} />
      </div>
    </PanelAnalisis>
  );
};

export default Contrapartes;
